import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import ElevatedRealEstateStrategy from "./sections/ElevatedRealEstateStrategy";
import PourquoiBoxify from "./sections/PourquoiBoxify";
import ServiceOverview from "./sections/ServiceOverview";
import ByTheNumbers from "./sections/ByTheNumbers";
import QualityJourney from "./sections/QualityJourney";
import Testimonials from "./sections/Testimonials";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <ElevatedRealEstateStrategy />
      <PourquoiBoxify />
      <ServiceOverview />
      <ByTheNumbers />
      <QualityJourney />
      <Testimonials />
      <Footer />
    </div>;
}